import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppUrlConstants } from "../constants/AppUrlConstants";

export interface CrudOperations {
  getAll(url: string): Observable<any[]>;
  getById(id: number, url: string): Observable<any>;
  add(item: any, url: string): Observable<any>;
  edit(item: any, url: string): Observable<any>;
  delete(id: number, url: string): Observable<void>;
}

@Injectable({
  providedIn: "root",
})
export class GenericCrudService implements CrudOperations {
  constructor(private http: HttpClient) {}

  // getAll(url: string): Observable<any[]> {
  //   return this.http.get<any[]>(AppUrlConstants.host + url);
  // }
  
 getAll(url: string, options: any = {}): Observable<any> {
  return this.http.get(AppUrlConstants.host + url, options);
}
  search(item: any, url: string): Observable<any[]> {
    return this.http.post<any>(AppUrlConstants.host + url, item);
  }

  getById(id: number, url: string): Observable<any> {
    return this.http.get<any>(AppUrlConstants.host + `${url}/${id}`);
  }

  add(item: any, url: string): Observable<any> {
    return this.http.post<any>(AppUrlConstants.host + url, item);
  }

  edit(item: any, url: string): Observable<any> {
    return this.http.post<any>(AppUrlConstants.host + `${url}`, item);
  }
  put(item: any, url: string): Observable<any> {
    return this.http.put<any>(AppUrlConstants.host + `${url}`, item);
  }
  delete(id: number, url: string): Observable<void> {
    return this.http.delete<void>(AppUrlConstants.host + `${url}/${id}`);
  }
  getDivision(url: string): Observable<void> {
    return this.http.get<void>(AppUrlConstants.host + url);
  }
  getByType(type: string, url: string): Observable<void> {
    return this.http.get<void>(AppUrlConstants.host + `${url}/${type}`);
  }
// In your GenericCrudService
// update(item: any, url: string): Observable<any> {
//     return this.http.put<any>(AppUrlConstants.host + url, item); // Correct implementation
//   }
}
